import type { SnapshotFrom } from 'xstate';

import { localStorage } from '@change-corgi/core/storage';

import { schema } from '../../../shared/schema';
import type { machine } from '../../machine';

type StateValue<MACHINE> = SnapshotFrom<MACHINE>;
type StateContextDraft = StateValue<typeof machine>['context']['draft'];
type Draft = Omit<StateContextDraft, 'id'>;
/*
 * Update the draft in local storage
 * TODO: add debounce to avoid excessive writes
 */
export const updateDraft = async (id: string, draft: Draft): Promise<void> => {
	// eslint-disable-next-line promise/avoid-new
	return new Promise((resolve, reject) => {
		const updatedDraft = { id, ...draft };
		const result = schema.safeEncode(updatedDraft);

		if (!result.success) {
			reject(new Error('Draft schema validation failed'));
			return;
		}

		localStorage.setItem('draft-id', id);
		localStorage.setItem(`draft-${id}`, result.data);
		resolve();
	});
};
